<template>
    <div id="aliyun-range"></div>
</template>

<script>
export default {
    name: 'AlyRange',
    props: {
        scene: {
            type: String,
            default: 'login'
        },
        width: {
            type: Number,
            default: 354
        }
    },
    data() {
        return {
            ncObj: null
        };
    },
    mounted() {
        this.initRange();
    },
    methods: {
        initRange() {
            const that = this;
            // 实例化nc
            AWSC.use('nc', function(state, module) {
                const ncOption = {
                    // 应用类型标识。它和使用场景标识（scene字段）一起决定了滑动验证的业务场景与后端对应使用的策略模型。您可以在阿里云验证码控制台的配置管理页签找到对应的appkey字段值，请务必正确填写。
                    appkey: 'FFFF0N3N0000000069E7',
                    //使用场景标识。它和应用类型标识（appkey字段）一起决定了滑动验证的业务场景与后端对应使用的策略模型。您可以在阿里云验证码控制台的配置管理页签找到对应的scene值，请务必正确填写。
                    scene: that.scene,
                    // 声明滑动验证需要渲染的目标ID。
                    renderTo: 'aliyun-range',
                    width: that.width,
                    //前端滑动验证通过时会触发该回调参数。您可以在该回调参数中将会话ID（sessionId）、签名串（sig）、请求唯一标识（token）字段记录下来，随业务请求一同发送至您的服务端调用验签。
                    success: function(data) {
                        // console.log(data)
                        // window.console && console.log(data.sessionId)
                        // window.console && console.log(data.sig)
                        // window.console && console.log(data.token)
                        const { sessionId, sig, token } = data;
                        that.$emit('success', { sessionId, sig, token });
                    },
                    // 滑动验证失败时触发该回调参数。
                    fail: function(failCode) {
                        window.console && console.log(failCode);
                    },
                    // 验证码加载出现异常时触发该回调参数。
                    error: function(errorCode) {
                        window.console && console.log(errorCode);
                    }
                }; // 滑动验证初始化参数
                // 初始化 调用module.init对滑动验证进行初始化
                that.ncObj = module.init(ncOption);
            });
        },
        resetRange() {
            if (this.ncObj) {
                // console.log('start reset range')
                this.ncObj.reset();
            }
        }
    }
};
</script>

<style>
.btn_slide {
    height: 34px !important;
}
.btn_ok {
    height: 34px !important;
}
.nc-lang-cnt {
    height: 34px !important;
}
.sm-pop-inner {
    width: auto !important;
    left: 50%;
    transform: translateX(-50%);
}
</style>
